// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class PrivacyPolicyResource extends Resource {
    basePath: string = 'web/privacy/';

    objectPath: string = 'web/privacy/{ident}/';
}
